import {http} from "../http";
import {getCurrentCompany} from "../user";

export interface AccountNickname{
    IBAN : string;
    NICKNAME : string;
}

export const updateAccountNickname = async (request_data: AccountNickname): Promise<AccountNickname> => {    
    let customer_no=getCurrentCompany().customerNo;
    const { data } = await http.post<AccountNickname>(`customers/${customer_no}/accounts/nickname`, request_data);
    return data;
};
